module.exports = __webpack_public_path__ + "img/big_gold_coin.cdf5e622.png";